import { render } from "./DialogRules.vue?vue&type=template&id=2e5efe7d"
import script from "./DialogRules.vue?vue&type=script&lang=js"
export * from "./DialogRules.vue?vue&type=script&lang=js"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/eventos-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__